module.exports = __webpack_public_path__ + "static/media/aboutme.15f5c244.jpg";